import { FormattedMessage } from "react-intl";
import { AttentionIcon } from "../../components/Icons";
import { WarningContainer } from "../styles";

export default function Warning() {
  return (
    <WarningContainer>
      <AttentionIcon color="#62748E" size={20} />
      <FormattedMessage id="cancel_purchase_info" />
    </WarningContainer>
  );
}
